/* src/app/views/product-create-search/view-plans/view-plans.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
  width: 100%;
  max-width: none;
  margin: 0 0 24px;
  box-sizing: border-box;
  border-radius: 6px;
  overflow: visible;
  padding: 0 0 24px;
  position: relative;
}
.title {
  font-weight: normal;
  font-style: normal;
  font-size: 30pt;
  line-height: 50px;
  color: #333333;
  margin: 0;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 26px 36px 10px;
  box-sizing: border-box;
}
.container-header > [class*=col-] {
  padding: 0;
}
.header-title-col {
  display: flex;
  align-items: center;
}
.header-action-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.container-body {
  padding: 0 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
}
.new-plans {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.new-plans-i {
  color: #102b4e;
}
.new-plans-label {
  vertical-align: middle;
}
:host ::ng-deep .new-plans .p-dropdown {
  min-width: 154px;
  min-height: 44px;
  border-radius: 10px;
}
.search-filters-wrapper,
.search-results {
  width: 100%;
  box-sizing: border-box;
}
.search-filters-wrapper {
  padding: 0;
}
:host ::ng-deep .search-filters-wrapper .p-accordion,
:host ::ng-deep .search-filters-wrapper .ui-accordion {
  width: 100%;
}
:host ::ng-deep .search-filters-wrapper .p-accordion .p-accordion-tab,
:host ::ng-deep .search-filters-wrapper .ui-accordion .ui-accordion-tab {
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
}
:host ::ng-deep .search-filters-wrapper .p-accordion .p-accordion-header .p-accordion-header-link,
:host ::ng-deep .search-filters-wrapper .ui-accordion .ui-accordion-header a {
  min-height: 58px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: #f5f7fb;
}
::ng-deep .search-filters-wrapper .p-accordion .p-accordion-content {
  padding: 20px;
}
:host ::ng-deep .search-filters-wrapper .p-accordion-content,
:host ::ng-deep .search-filters-wrapper .ui-accordion-content {
  border-top: 1px solid #d9d9d9;
  background: #ffffff;
}
.filters-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 10px;
  align-items: start;
  width: 100%;
  margin: 8px 0 0;
}
.filters-grid > [class*=col-] {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
  margin: 0;
}
::ng-deep #typeQueryNew.p-dropdown,
::ng-deep #typeQueryNew .p-dropdown,
::ng-deep #typeQueryNew.ui-dropdown,
::ng-deep #typeQueryNew .ui-dropdown {
  min-height: 44px !important;
  height: 44px !important;
  display: inline-flex;
  align-items: center;
}
::ng-deep #typeQueryNew .p-dropdown-label,
::ng-deep #typeQueryNew .ui-dropdown-label {
  min-height: 44px !important;
  height: 44px !important;
  display: inline-flex;
  align-items: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.selected-edit {
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.selected-edit-title {
  display: inline-block;
  padding: 0;
  margin-bottom: 6px;
  min-height: 22px;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.35;
  color: #3f464d;
}
.selected-edit-field {
  align-items: flex-end;
}
:host ::ng-deep .search-results .p-datatable {
  width: 100%;
}
:host ::ng-deep .search-results .p-datatable-wrapper {
  overflow-x: auto;
}
:host ::ng-deep .search-results .p-datatable .p-paginator {
  border-top: 1px solid #d9d9d9;
}
:host ::ng-deep .search-results .p-datatable .p-datatable-empty-message > td,
:host ::ng-deep .search-results .p-datatable .p-datatable-emptymessage > td {
  text-align: left !important;
}
:host ::ng-deep .search-results .p-datatable .p-datatable-empty-message > td[colspan],
:host ::ng-deep .search-results .p-datatable .p-datatable-emptymessage > td[colspan] {
  position: static !important;
  right: auto !important;
  z-index: auto !important;
  box-shadow: none !important;
}
.table-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  border: none;
  background: #046cea;
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: none;
}
.table-action-btn:hover {
  background: #0359be;
}
.table-action-btn:focus-visible {
  outline: 2px solid #046cea;
  outline-offset: 2px;
}
:host ::ng-deep .search-results .p-datatable-thead > tr > th.actions-col-header,
:host ::ng-deep .search-results .p-datatable-tbody > tr > td.actions-col {
  width: 92px !important;
  min-width: 92px !important;
  max-width: 92px !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
}
:host ::ng-deep .search-results .p-datatable-tbody > tr > td.actions-col .actions-col-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
:host ::ng-deep .price-results-table .p-datatable-table {
  min-width: 860px;
  table-layout: auto !important;
}
:host ::ng-deep .product-results-table .p-datatable-table {
  min-width: 980px;
  table-layout: auto !important;
}
:host ::ng-deep .coverage-results-table .p-datatable-table {
  min-width: 1080px;
  table-layout: auto !important;
}
:host ::ng-deep .eligibility-table .p-datatable-table {
  min-width: 1560px;
  table-layout: auto !important;
}
:host ::ng-deep .product-results-table .product-name-col,
:host ::ng-deep .coverage-results-table .product-name-col {
  width: 380px !important;
  min-width: 380px !important;
}
:host ::ng-deep .price-results-table .price-description-col {
  width: 380px !important;
  min-width: 380px !important;
}
:host ::ng-deep .eligibility-table .eligibility-col-product {
  width: 360px !important;
  min-width: 360px !important;
}
:host ::ng-deep .eligibility-table .eligibility-col-coverage {
  width: 320px !important;
  min-width: 320px !important;
}
:host ::ng-deep .eligibility-table .eligibility-col-description {
  width: 420px !important;
  min-width: 420px !important;
}
@media (max-width: 900px) {
  .container-header {
    padding: 22px 24px 10px;
  }
  .container-body {
    padding: 0 24px;
  }
  .filters-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .selected-edit-title {
    font-size: 15px;
    line-height: 20px;
  }
  .button-position {
    justify-content: flex-end;
  }
}
.action-button-clean:hover:not(:disabled) {
  background: #044ea7;
}
button.action-button-clean:hover:not(:disabled) .action-button-clean-label {
  color: #ffffff;
}
.btn-search:disabled {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.btn-search:disabled * {
  color: #202020;
  pointer-events: none;
  opacity: 0.7;
}
.action-button-clean:disabled {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.action-button-clean:disabled * {
  color: #202020;
  pointer-events: none;
  opacity: 0.7;
}
::ng-deep .search-results .p-datatable .p-datatable-tbody > tr.results-row > td {
  font-size: 1.0625rem;
  line-height: 1.4;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 16px 0 0;
  padding-top: 14px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.btn-search {
  width: 170px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.btn-search-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-search:hover:not(:disabled) {
  background: #044ea7;
}
.action-button-clean {
  width: 170px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.action-button-clean-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.action-button-clean:hover:not(:disabled) {
  background: #044ea7;
}
button.action-button-clean:hover:not(:disabled) .action-button-clean-label {
  color: #ffffff;
}
.btn-search:disabled {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.btn-search:disabled * {
  color: #202020;
  pointer-events: none;
  opacity: 0.7;
}
.action-button-clean:disabled {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.7;
}
.action-button-clean:disabled * {
  color: #202020;
  pointer-events: none;
  opacity: 0.7;
}
@media (max-width: 1200px) {
  .title {
    font-size: 28pt;
    line-height: 38px;
  }
  .btn-search,
  .action-button-clean {
    width: 120px;
    height: 44px;
  }
  .colum-width,
  .colum-width-small-text,
  .colum-width-medium-text,
  .colum-width-price-text,
  .colum-width-large-text,
  .colum-width-btn,
  .view-column,
  .view-button-size,
  .view-button-size-small {
    width: auto !important;
    min-width: 50px;
  }
}
@media (max-width: 600px) {
  .filters-grid {
    grid-template-columns: 1fr;
    row-gap: 10px;
    width: 100%;
    margin: 8px 0 0;
  }
  .title {
    font-size: 16pt;
    line-height: 22px;
  }
  .container-header {
    padding: 18px 16px 10px;
  }
  .container-body {
    padding: 0 16px;
    gap: 18px;
  }
  .header-action-col {
    justify-content: flex-start;
    margin-top: 12px;
  }
  .button-position {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    width: 100%;
    margin: 14px 0 0;
  }
  .btn-search,
  .action-button-clean {
    width: 100%;
    max-width: none;
  }
  .colum-width,
  .colum-width-small-text,
  .colum-width-medium-text,
  .colum-width-price-text,
  .colum-width-large-text,
  .colum-width-btn,
  .view-column,
  .view-button-size,
  .view-button-size-small {
    width: 100% !important;
    min-width: 0;
  }
}
.btn-search,
.action-button-clean {
  min-width: 100px;
  max-width: 180px;
  width: 170px;
  margin-right: 0;
  margin-bottom: 0;
  box-sizing: border-box;
}
::ng-deep #excel-table-eligibility .eligibility-table .p-datatable-wrapper {
  overflow-x: auto;
}
::ng-deep #excel-table-eligibility .eligibility-table .p-datatable-table {
  min-width: 2140px;
  table-layout: auto !important;
}
::ng-deep #excel-table-eligibility .eligibility-table .p-datatable-thead > tr > th,
::ng-deep #excel-table-eligibility .eligibility-table .p-datatable-tbody > tr > td {
  white-space: nowrap !important;
  word-break: keep-all;
  overflow-wrap: normal;
  vertical-align: middle;
}
.eligibility-col-country {
  min-width: 140px;
}
.eligibility-col-status {
  min-width: 120px;
}
.eligibility-col-product {
  min-width: 460px;
}
.eligibility-col-coverage {
  min-width: 360px;
}
.eligibility-col-vehicle {
  min-width: 340px;
}
.eligibility-col-description {
  min-width: 320px;
}
.eligibility-col-price {
  min-width: 180px;
}
.eligibility-col-sale-type {
  min-width: 160px;
}
.eligibility-col-actions {
  min-width: 110px;
}
::ng-deep #excel-table-product .product-results-table .p-datatable-wrapper,
::ng-deep #excel-table-coverage .coverage-results-table .p-datatable-wrapper {
  overflow-x: auto;
}
::ng-deep #excel-table-product .product-results-table .p-datatable-table {
  min-width: 860px;
  table-layout: auto !important;
}
::ng-deep #excel-table-coverage .coverage-results-table .p-datatable-table {
  min-width: 1080px;
  table-layout: auto !important;
}
::ng-deep #excel-table-product .product-results-table .product-name-col,
::ng-deep #excel-table-coverage .coverage-results-table .product-name-col {
  min-width: 320px;
  white-space: nowrap !important;
  word-break: keep-all;
  overflow-wrap: normal;
}
/*# sourceMappingURL=view-plans.component-7JBDAB2M.css.map */
